import * as React from 'react';
import { ElementLoader } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

export interface RefreshCacheModalProps {
  translation?: any;
  onClose: () => void;
  fetchingRefreshCache: boolean;
  executeRefreshCache: () => void;
}

export const RefreshCacheModal: React.FC<RefreshCacheModalProps> = (props: RefreshCacheModalProps) => {
    const { fetchingRefreshCache, translation } = props;
    return (
      <ModalWrapper
        headerTitle={translation.refresh_cache_title}
        btnTitle={props.translation.refresh_cache_submit_button}
        btnCancelTitle={props.translation.refresh_cache_cancel}
        onDone={props.executeRefreshCache}
        onClose={props.onClose}
        closeOnDone={false}
        isDisabled={fetchingRefreshCache}
        largeSize={false}>
        {fetchingRefreshCache ? <div>
          {<ElementLoader />}
        </div> : props.translation.refresh_cache_description}
      </ModalWrapper>
    );
};
